<template>
  <div
    class="min-h-screen bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50 dark:from-gray-900 dark:via-gray-900 dark:to-gray-950 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8"
  >
    <div class="max-w-md w-full space-y-8">
      <!-- Login Card -->
      <div class="card animate-fade-in dark:bg-gray-900">
        <div class="card-header text-center dark:border-gray-800">
          <h1
            class="text-3xl font-bold text-primary-600 dark:text-primary-400 mb-2"
          >
            Fira Sport
          </h1>
          <p class="text-gray-600 dark:text-gray-400">Admin Portal</p>
        </div>

        <div class="card-body dark:text-gray-100">
          <form @submit.prevent="login" class="space-y-6">
            <!-- Username Field -->
            <div>
              <label class="form-label dark:text-gray-300">Username</label>
              <div class="relative">
                <div
                  class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
                >
                  <svg
                    class="h-5 w-5 text-gray-400"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                    />
                  </svg>
                </div>
                <input
                  v-model="username"
                  type="text"
                  required
                  class="form-input pl-10 dark:bg-gray-800 dark:border-gray-700 dark:placeholder-gray-500 dark:text-gray-100"
                  placeholder="Enter your username"
                />
              </div>
            </div>

            <!-- Password Field -->
            <div>
              <label class="form-label dark:text-gray-300">Password</label>
              <div class="relative">
                <div
                  class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
                >
                  <svg
                    class="h-5 w-5 text-gray-400"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                    />
                  </svg>
                </div>
                <input
                  v-model="password"
                  type="password"
                  required
                  class="form-input pl-10 dark:bg-gray-800 dark:border-gray-700 dark:placeholder-gray-500 dark:text-gray-100"
                  placeholder="Enter your password"
                />
              </div>
            </div>

            <!-- Login Button -->
            <div>
              <button
                type="submit"
                :disabled="adminLoginLoading"
                class="w-full btn btn-primary btn-lg"
              >
                <svg
                  v-if="adminLoginLoading"
                  class="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    class="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    stroke-width="4"
                  ></circle>
                  <path
                    class="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  ></path>
                </svg>
                <svg
                  v-else
                  class="w-5 h-5 mr-2"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1"
                  />
                </svg>
                {{ adminLoginLoading ? "Signing in..." : "Sign in" }}
              </button>
            </div>
          </form>
        </div>
      </div>

      <!-- Footer -->
      <div class="text-center">
        <p class="text-sm text-gray-500 dark:text-gray-400">
          Secure access to Fira Sport management system
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data: () => ({
    username: "",
    password: "",
    adminLoginLoading: false,
    ipAddress: "",
  }),

  methods: {
    async login() {
      if (this.password == "a" && this.username == "a") {
        this.adminLoginLoading = true;

        // try {
        //   var adminLoginResult = await axios({
        //     method: "POST",
        //     url: this.$store.state.bingoAdminURL,

        //     data: {
        //       query: `{
        //        adminLogin(user_name:"${this.username}",password:"${this.password}"){
        //              admin_id
        //              user_name
        //              password

        //            }
        //       }
        //       `,
        //     },
        //   });

        //   if (adminLoginResult.data.data.adminLogin.length > 0) {
        //     this.$store.dispatch(
        //       "loginAdmin",
        //       adminLoginResult.data.data.adminLogin[0]
        //     );
        //     this.$router.push({ name: "home" });
        //   } else alert("Please enter correct username and password");
        // } catch (err) {
        //   alert(err);
        // }
        this.$store.dispatch("loginAdmin", "a");
        this.$router.push({ name: "home" });
        this.adminLoginLoading = false;
      } else {
        alert("Please enter correct username and password");
      }
    },
  },
  created() {
    // this.ipAddress = this.$store.state.bingoAdminURL.split(":")[1].split("//")[1];
    // if (this.$store.state.admin != "") this.$router.push({ name: "home" });
    // this.$store.dispatch("loginCashier", false);
  },
};
</script>

<style scoped>
/* Custom animations */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.animate-fade-in {
  animation: fadeIn 0.6s ease-out;
}
</style>
